import bcrypt from "bcryptjs";
import { z } from "zod";

/** Minimum for new passwords (signup, reset, change). */
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;

export const passwordSchema = z
  .string()
  .min(
    PASSWORD_MIN_LENGTH,
    `Password must be at least ${PASSWORD_MIN_LENGTH} characters`,
  )
  .max(
    PASSWORD_MAX_LENGTH,
    `Password must be at most ${PASSWORD_MAX_LENGTH} characters`,
  );

/** Login: any non-empty password (supports legacy 6-digit PINs). */
export const loginPasswordSchema = z
  .string()
  .min(1, "Password is required")
  .max(PASSWORD_MAX_LENGTH);

export async function hashPassword(plain: string): Promise<string> {
  return bcrypt.hash(plain, 10);
}

export async function verifyPassword(
  plain: string,
  hashed: string,
): Promise<boolean> {
  return bcrypt.compare(plain, hashed);
}
